// extracted by mini-css-extract-plugin
export var banner = "_32-0";
export var icon = "_32-1";
export var message = "_32-2";